<template>
  <div class="noti-item">
    <img :src="getIcon(item.Title)" class="noti-icon" alt="" />
    <div class="noti-content">
      <div class="title-row">
        <p class="title" :class="item.IsRead ? 'title-read' : ''">{{ item.Title }}</p>
        <span class="noti-time" :class="!item.IsRead ? 'unread' : ''">
          {{ formatTimeAgo(item.SentAt) }}
        </span>
      </div>
      <p class="desc" v-html="item.Message"></p>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: ["item"],
  data: () => ({}),
  mounted() { },
  created() { },
  computed: {
    user_info() {
      return this.$store.state.user_info;
    },
  },
  methods: {
    formatTimeAgo(dateString) {
      if (!dateString) return "Unknown";

      const now = moment().tz(this.user_info.timezone);
      const date = moment.utc(dateString).tz(this.user_info.timezone);
      const diffHours = now.diff(date, "hours");
      const diffMinutes = now.diff(date, "minutes");

      if (diffHours < 24) {
        if (diffHours < 1) {
          return `${diffMinutes} ${diffMinutes === 1 ? "minute" : "minutes"
            } ago`;
        } else {
          return `${diffHours} ${diffHours === 1 ? "hour" : "hours"} ago`;
        }
      } else {
        return moment
          .utc(dateString)
          .tz(this.user_info.timezone)
          .format("MM/DD/YYYY hh:mm A");
      }
    },
    getIcon(iconType) {
      switch (iconType.toLowerCase()) {
        case "Upcoming due date".toLowerCase():
        case "Assignment updated".toLowerCase():
        case "Test updated".toLowerCase():
        case "Flex assignment updated".toLowerCase():
          return "/themes/web/assets/images/icon/update_noti.svg";
        case "Assignment graded".toLowerCase():
        case "Flex assignment graded".toLowerCase():
        case "Test graded".toLowerCase():
        case "Assignment score changed".toLowerCase():
        case "Test score changed".toLowerCase():
        case "New feedback".toLowerCase():
        case "Feedback updated".toLowerCase():
          return "/themes/web/assets/images/icon/asm_noti.svg";
        case "New flex assignment".toLowerCase():
          return "/themes/web/assets/images/icon/new_fasm_noti.svg";
        case "Allow retry".toLowerCase():
          return "/themes/web/assets/images/icon/allow_retry_noti.svg";
        default:
          return "/themes/web/assets/images/icon/new_course_noti.svg";
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  margin: 12px 0 8px;
  color: #777777;
}

.noti-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  position: relative;
}

.noti-icon {
  width: 40px;
  height: 40px;
  margin-top: 2px;
}

.noti-content {
  flex: 1;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.noti-content .title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 2px;
  color: black;
}

.noti-content .desc {
  font-size: 12px;
  color: #555;
}

.noti-time {
  font-size: 12px;
  color: #777777;
  white-space: nowrap;
}

.title-read {
  color: #403D3D !important;
}

.unread {
  color: #03a9f4 !important;
}
</style>
